const USD  = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
const USD2 = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function fmtUSD(n: number | null | undefined): string {
  return n == null ? '—' : USD.format(n);
}

export function fmtUSD2(n: number | null | undefined): string {
  return n == null ? '—' : USD2.format(n);
}

export function fmtPct(r: number | null | undefined, decimals = 3): string {
  return r == null ? '—' : `${(r * 100).toFixed(decimals)}%`;
}
